import React from 'react';
import cssmodules from 'react-css-modules';
import styles from './ideapage.cssmodule.scss';
import CreateIdeaButton from '../Shared/CreateIdeaButton';
import InitiativeForm from './InitiativeForm';
import CIPForm from './CIPForm';
import CreateIdeasHeader from '../Shared/CreateIdeasHeader';
import {Panel, FormControl, Button} from 'react-bootstrap';
import {injectIntl, intlShape, FormattedRelative} from 'react-intl';

import {INITIATIVE_TYPE, CIP_TYPE} from '../../constants';

var NotificationSystem = require('react-notification-system');




class IdeaPage extends React.Component {

  constructor(props) {
    super(props);
    const {ideaType } = this.props;
    this.state = {ideaType : ideaType};
  }

  componentDidMount() {
    const { cipGroups } = this.props;
    const { ideaType } = this.props;
    const { actions } = this.props;
    if(ideaType == CIP_TYPE){
        actions.fetchCipGroupsAction();
    }else{
        actions.fetchInitiativeTypesAction();
    }
    this._notificationSystem = this.refs.notificationSystem;
  }

  componentWillReceiveProps(nextProps) { 
    const { ideaType } = nextProps;
    const { actions } = nextProps;

    if(ideaType != this.state.ideaType){
      if(ideaType == CIP_TYPE){
        actions.fetchCipGroupsAction();
      }
      else
      {
        actions.fetchInitiativeTypesAction();
      }
      this.setState({ideaType : ideaType});
    }
  }

  postCipIdea(cipIdea){
    const { actions } = this.props;
    var self = this;
    const {intl} = this.props;
    const t = (message, data = {}) => {
        return intl.formatMessage({id : message}, data);
    };
    return actions.postCipIdeaAction(cipIdea).then((resp) => {
       if(resp.value){
            this._notificationSystem.addNotification({
              title : t("Success"),
              message: t('CI Proposal created') + ': #' + resp.value.Id,
              level: 'success',
              position : 'br'
          });
          setTimeout(() => {
              self.props.router.push('/browse-ideas/' + this.state.ideaType)
          },3000);
      }
      return resp;
    });
  }

  postInitiative(initiative, files){
    const { actions } = this.props;
    var self = this;
    const {intl} = this.props;
    const t = (message, data = {}) => {
        if(!message) return '';
        return intl.formatMessage({id : message}, data);
    };
    return actions.addInitiativeAction(initiative, files).then((resp) => {
        if(resp.value){
             this._notificationSystem.addNotification({
                title : t("Success"),
                message: t('Initiative created') + ': #' + resp.value.Id,
                level: 'success',
                position : 'br'
            });
            setTimeout(() => {
              self.props.router.push('/browse-ideas/' + this.state.ideaType)
            },3000);
        }
        return resp;
    });
  }




  render() {    
    const {intl} = this.props;
    
    const t = (message, data = {}) => {
        if(!message) return '';
        return intl.formatMessage({id : message}, data);
    };


    const { cipGroups } = this.props;
    const { actions } = this.props;
    const { initiativeTypes } = this.props;
    const {locale} = this.props;

    

    const {ideaType} = this.props;
    return (
       <div className="container" styleName="ideapage-component" >
        <NotificationSystem ref="notificationSystem" />
        <CreateIdeasHeader ideaType = {this.props.ideaType}/>
        <div className="row" styleName="form-container">
          <div className="col-md-8">
            <Panel>
              {this.props.ideaType == CIP_TYPE ? (
                <CIPForm locale={this.props.locale} cipGroups={cipGroups} onPostCipIdea={this.postCipIdea.bind(this)}/>
              ) : (
                <InitiativeForm locale={this.props.locale} initiativeTypes={initiativeTypes ? initiativeTypes : []} onPostIdea={this.postInitiative.bind(this)} onFetchUserManager = {actions.fetchManagerAction}/>
              )}
            </Panel>
          </div>
          <div className="col-md-4">
               <Panel header={t('GOOD TO KNOW')} className="brand-panel">
                      <p>{t(ideaType == CIP_TYPE ? 'CIP_DESC' : 'INITIATIVE_DESC')}</p>
               </Panel>
          </div>
        </div>
      </div>
    );
  }
}

IdeaPage.displayName = 'IdeaPage';
IdeaPage.propTypes = {};
IdeaPage.defaultProps = {
  
};
export default injectIntl(cssmodules(IdeaPage, styles));




// WEBPACK FOOTER //
// ./components/MakeIdeas/IdeaPage.js